<template>
  <div @click="onSelect" class="service-item">
    <div class="service-item__icon">
      <img :src="item.getLogo()">
    </div>
    <div class="service-item__layout">
      <div class="service-item__text-title">
        {{ item.name }}
      </div>
      <div class="service-item__text-desc">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
import MenuItem from '@/app/service/api/model/menu-item'

export default {
  name: 'item',
  props: {
    item: {
      type: MenuItem
    }
  },
  methods: {
    onSelect() {
      this.$emit('select', this.item)
    }
  }
}
</script>
